var map = {
	"./agent.svg": "7102",
	"./attach.svg": "7b65",
	"./call.svg": "6905",
	"./chat.svg": "e77f",
	"./close.svg": "5b98",
	"./download.svg": "1574",
	"./fullscreen.svg": "767d",
	"./glasses.svg": "fc14",
	"./minimize.svg": "686c",
	"./person.svg": "ce9e",
	"./phone.svg": "b60b",
	"./robot.svg": "9537",
	"./send.svg": "f8dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bcb7";